import {Link} from "react-router-dom";
import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import SoftBox from "../../../components/SoftBox";
import SoftTypography from "../../../components/SoftTypography";
import SoftButton from "../../../components/SoftButton";
import LogoGenerator from "../../../utils/logoGenerator";
import {Chip} from "@mui/material";

function BranchCard({image, branch, action, actions, onCompanyClick}) {
    console.log('BranchCard received image:', image);
    console.log('BranchCard branch name:', branch?.name);
    
    return (
        <Card
            sx={{
                display: "flex",
                flexDirection: "column",
                backgroundColor: "transparent",
                boxShadow: "none",
                overflow: "visible",
            }}
        >
            <SoftBox position="relative" width="100.25%" shadow="xl" borderRadius="xl">
                <img
                    src={image || LogoGenerator.generateFallbackLogo()}
                    alt={branch.name}
                    onError={(e) => {
                        console.error('Image failed to load:', e.target.src);
                        console.error('Alt text:', branch.name);
                        console.error('Image element:', e.target);
                    }}
                    onLoad={() => {
                        console.log('Image loaded successfully for:', branch.name);
                        console.log('Image src:', image || LogoGenerator.generateFallbackLogo());
                    }}
                    style={{
                        maxWidth: "100%",
                        width: "100%",
                        height: "200px",
                        margin: 0,
                        boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "12px",
                    }}
                />
            </SoftBox>
            <SoftBox pt={3} px={0.5}>
                <SoftBox mb={1}>
                    <SoftTypography
                        component="label"
                        variant="h5"
                        textTransform="capitalize"
                    >
                        {branch.name}
                    </SoftTypography>
                </SoftBox>
                <SoftBox mb={1}>
                    {branch.companyName && branch.companyName !== "N/A" ? (
                        <SoftTypography
                            variant="button"
                            fontWeight="medium"
                            color="primary"
                            sx={{cursor: "pointer", "&:hover": {textDecoration: "underline"}}}
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                onCompanyClick?.(branch);
                            }}
                        >
                            {branch.companyName}
                        </SoftTypography>
                    ) : (
                        <SoftTypography variant="button" fontWeight="regular" color="text">
                            {branch.companyName || "N/A"}
                        </SoftTypography>
                    )}
                </SoftBox>
                <SoftBox mb={2} lineHeight={0}>
                    <SoftTypography variant="h6" fontWeight="medium" color="text">
                        {branch.address}
                    </SoftTypography>
                </SoftBox>
                <SoftBox mb={2}>
                    <Chip
                        icon={(branch.faceDetectionEnabled === true) ? "👁️" : "🚫"}
                        label={(branch.faceDetectionEnabled === true) ? "Face Detection ON" : "Face Detection OFF"}
                        color={(branch.faceDetectionEnabled === true) ? "success" : "error"}
                        size="small"
                        variant="outlined"
                    />
                </SoftBox>
                <SoftBox mb={2}>
                    <Chip
                        icon={(branch.isActive === true) ? "🟢" : "🔴"}
                        label={(branch.isActive === true) ? "Active" : "Inactive"}
                        color={(branch.isActive === true) ? "success" : "default"}
                        size="small"
                        variant="outlined"
                    />
                </SoftBox>
                <SoftBox display="flex" justifyContent="space-between" alignItems="center">
                    <SoftButton
                        component={Link}
                        to={action.route}
                        variant="outlined"
                        size="small"
                        color={action.color}
                    >
                        {action.label}
                    </SoftButton>
                    <SoftBox display="flex" justifyContent="space-between" alignItems="center">
                        {actions?.map((act, index) => (
                            <SoftBox key={index} mx={1}>
                                {act}
                            </SoftBox>
                        ))}
                    </SoftBox>
                </SoftBox>
            </SoftBox>
        </Card>
    );
}

// Typechecking props for the BranchCard
BranchCard.propTypes = {
    branch: PropTypes.object.isRequired,
    image: PropTypes.string.isRequired,
    actions: PropTypes.arrayOf(PropTypes.node),
    onCompanyClick: PropTypes.func,
    action: PropTypes.shape({
        type: PropTypes.oneOf(["external", "internal"]),
        route: PropTypes.string.isRequired,
        color: PropTypes.oneOf([
            "primary",
            "secondary",
            "info",
            "success",
            "warning",
            "error",
            "light",
            "dark",
            "white",
        ]).isRequired,
        label: PropTypes.string.isRequired,
    }).isRequired,
};

export default BranchCard;
